// src/hooks/usePageTracking.js
// Fires a GA4 page_view on every client-side route change.
// Also handles first-load UTM capture and referrer tagging.
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView, captureUTMParams, captureReferrer } from '../utils/analytics';

const PAGE_TITLES = {
  '/': 'Home',
  '/about': 'About',
  '/product': 'Product',
  '/solutions': 'Solutions',
  '/pricing': 'Pricing',
  '/demo': 'Demo',
  '/resources': 'Resources',
  '/contact': 'Contact',
  '/login': 'Login',
  '/dashboard': 'Dashboard',
  '/privacy': 'Privacy Policy',
  '/terms': 'Terms of Service',
  '/onepager': 'Product One-Pager',
  '/wcag-checklist': 'WCAG Checklist',
  '/security-brief': 'Security Brief',
  '/translate': 'Translation Library',
  '/calculator': 'Eligibility Calculator',
  '/qr': 'QR Landing',
};

const usePageTracking = () => {
  const location = useLocation();
  const isFirstLoad = useRef(true);

  useEffect(() => {
    // On first load, capture UTM params and referrer before first page view
    if (isFirstLoad.current) {
      captureUTMParams();
      captureReferrer();
      isFirstLoad.current = false;
    }

    // Resolve title — handles dynamic translate routes
    let title = PAGE_TITLES[location.pathname];
    if (!title && location.pathname.startsWith('/translate/')) {
      const parts = location.pathname.split('/');
      title = `Translation: ${parts[2] || ''} (${parts[3] || ''})`;
    }

    trackPageView(location.pathname, title || document.title);
  }, [location.pathname]);
};

export default usePageTracking;
